// The size the card picked, only when it really is a piece of this product's
// stock. The message comes from the shop's page, which names the product and
// the pick; the catalogue decides. Anything else adds the product's default.

/**
 * @param {object} product  the catalogue's product, with variants and stocks
 * @param {*}      wanted   the stock id the card picked, if any
 * @returns {*} the stock id to add, or null when the product has none
 */
export function chosenStock(product, wanted) {
  if (!product) return null;
  if (wanted != null) {
    const stocks = (product.variants || [])
      .flatMap((variant) => (variant && variant.stocks) || []);
    const match = stocks.find((stock) => stock && String(stock.id) === String(wanted));
    if (match) return match.id;
  }
  return product.stock_id ?? null;
}

export default chosenStock;
